import React, { useCallback, useState, useEffect } from "react";
import {
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
  Stack,
  Box,
} from "@mui/material";
import HelpButton from "../../../Buttons/HelpButton/HelpButton";

const imgLength = "clamp(200px, 20vw, 450px)";

const MountTypeSelector = ({
  onChange,
  defaultMountType,
  value,
  title,
  mountTypes = [
    {
      image: { alt: "", src: "" },
      help: <></>,
      label: "",
      value: "",
    },
  ],
}) => {
  const [mountType, setMountType] = useState(defaultMountType);

  useEffect(() => {
    value && setMountType(value);
  }, [value]);

  const handleMountTypeChange = useCallback(
    (e) => {
      const newMountType = e.target.value;
      setMountType(newMountType);
      onChange && onChange(newMountType);
    },
    [onChange]
  );

  return (
    <>
      <Typography variant="h6" sx={{ mt: 3 }}>
        {title}
      </Typography>
      <RadioGroup
        row
        value={mountType}
        onChange={handleMountTypeChange}
        sx={{
          justifyContent: "center",
          alignContent: "stretch",
          gap: 5,
        }}
      >
        {mountTypes.map((mountType) => (
          <Stack
            direction="column"
            alignItems="center"
            justifyContent="space-between"
            key={mountType.value}
          >
            <Box
              component="img"
              src={mountType.image.src}
              alt={mountType.image.alt}
              sx={{ width: imgLength }}
            />
            <Stack
              direction="column"
              alignItems="center"
              justifyContent="space-between"
            >
              <HelpButton>{mountType.help}</HelpButton>
              <FormControlLabel
                value={mountType.value}
                control={<Radio />}
                label={mountType.label}
              />
            </Stack>
          </Stack>
        ))}
      </RadioGroup>
    </>
  );
};

export default MountTypeSelector;
